<ng-container *transloco="let t">
  <tui-textfield data-testid="form-select" tuiChevron [content]="preview">
    <input
      tuiSelect
      [disabled]="disabled"
      [ngModel]="value"
      [placeholder]="placeholder"
      (ngModelChange)="onSelectChange($event)" />
    <tui-data-list-wrapper *tuiDropdown new [itemContent]="listItem" [items]="items$ | async" />
  </tui-textfield>
</ng-container>

<ng-template #preview let-item>
  <span>{{ item.title || item.form?.title }}</span>
</ng-template>

<ng-template #listItem let-item>
  <div>
    <p>{{ item.title || item.form?.title }}</p>
    @if (item.description) {
      <p class="text-sm text-text-tertiary">{{ item?.description }}</p>
    }
  </div>
</ng-template>
